import(/* webpackMode: "eager" */ "/vercel/path0/app/(chat)/chatbot/page.tsx");
